import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetParentSearchResultsQuery } from '@/services/parent-api';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import SearchPanel from './search-panel';
import SearchResults from './search-results';

const breadcrumb = [{ path: '/parent', label: 'Parents' }, 'Search'];

const ParentSearchPage = () => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const searchId = queryParams.get('q');
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetParentSearchResultsQuery({ searchId, pageNumber }, { skip: !searchId });
  const [results, setResults] = useState();

  useEffect(() => {
    if (!searchId) setResults();
  }, [searchId]);

  useEffect(() => {
    setResults(data);
  }, [data]);

  return (
    <Page breadcrumb={breadcrumb} size="xl">
      <PageTitle label="Parent Search" />
      <SearchPanel params={results?.criteria} />
      <SearchResults searchId={searchId} data={results} loading={isFetching} />
    </Page>
  );
};

export default ParentSearchPage;
